import { create } from 'zustand';

export type GpsDistanceData = {
    lat: number;
    lng: number;
};

type GpsDistanceFieldRef = {
    setDistance: (data: GpsDistanceData) => void;
    getDistance: () => GpsDistanceData | null;
};

interface BlockModalGpsDistanceState {
    fieldRef: GpsDistanceFieldRef | null;
    setFieldRef: (ref: GpsDistanceFieldRef) => void;
    clearFieldRef: () => void;
}

export const useBlockModalGpsDistanceStore = create<BlockModalGpsDistanceState>((set) => ({
    fieldRef: null,
    setFieldRef: (ref) => set({ fieldRef: ref }),
    clearFieldRef: () => set({ fieldRef: null }),
}));
